<template>
  <div>
    <el-form :model="searchForm" :inline="true">
      <el-form-item label="部门" prop="departId">
        <el-input v-model="searchForm.department" size="small" clearable/>
      </el-form-item>
      <el-form-item>
        <template>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchList()">查询</el-button>
          <el-button type="success" size="mini" icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="isloading"
      :data="tableData"
      :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}"
      border>
      <el-table-column label="管理部门" prop="department" align="center"/>
      <el-table-column label="第一部门秘书" prop="one_name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.one_name }} ({{ scope.row.one_workcode }})</span>
        </template>
      </el-table-column>
      <el-table-column label="第二部门秘书" prop="two_name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.two_name }} ({{ scope.row.two_workcode }})</span>
        </template>
      </el-table-column>
      <el-table-column label="部门负责人" prop="leader" align="center">
        <template slot-scope="scope">
          <div v-for="(item,i) in scope.row.leader.split(',')" :key='i'>
            <span>{{item ? item+'('+scope.row.leader_workcode.split(',')[i]+')' : ''}}</span>
          </div>
          <!-- <span>{{ scope.row.leader && scope.row.leader !== '' ? scope.row.leader+'('+scope.row.leader_workcode+')' : '' }}</span> -->
        </template>
      </el-table-column>
      <el-table-column label="部门BP" prop="sector_bp" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sector_bp && scope.row.sector_bp !== '' ? scope.row.sector_bp+'('+scope.row.sector_bp_workcode +')' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="议事规则" prop="rules" align="center" />

      <el-table-column label="是否可用" prop="is_available" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_available"
            :title="scope.row.is_available=='1'?'可用':'不可用'"
            active-color="#13ce66"
            inactive-color="#909399"
            active-value="1"
            inactive-value="0"
            disabled/>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editTab(scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog :visible.sync="addVisible" :close-on-click-modal="false" :before-close="closeAdd" width="800px" :title="isAdd ? '新增' : '编辑'">
      <el-form ref="addForm" :model="addForm" :rules="rule" style="padding-right: 35px">
        <el-form-item label="部门" prop="department" label-width="120px">
          <el-input v-model="addForm.department" clearable />
        </el-form-item>
        <el-form-item label="第一部门秘书" prop="one_person" label-width="120px">
          <el-select v-model="addForm.one_person" clearable filterable style="width: 100%">
            <el-option
              v-for="(item, index) in personList"
              :key="index"
              :label="item.name+'('+item.workcode+')'"
              :value="item.name+'/'+item.workcode"
              :disabled="isAdd && (item.name+'/'+item.workcode==addForm.two_person)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="第二部门秘书" prop="two_person" label-width="120px">
          <el-select v-model="addForm.two_person" clearable filterable style="width: 100%">
            <el-option
              v-for="(item, index) in personList"
              :key="index"
              :label="item.name+'('+item.workcode+')'"
              :value="item.name+'/'+item.workcode"
              :disabled="isAdd && (item.name+'/'+item.workcode==addForm.one_person)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="部门负责人" prop="leader_person" label-width="120px">
          <el-select v-model="addForm.leader_person" clearable multiple filterable style="width: 100%">
            <el-option
              v-for="(item, index) in personList"
              :key="index"
              :label="item.name+'('+item.workcode+')'"
              :value="item.name+'/'+item.workcode"/>
          </el-select>
        </el-form-item>
        <el-form-item label="部门BP" prop="sector_bp_person" label-width="120px">
          <el-select v-model="addForm.sector_bp_person" clearable filterable style="width: 100%">
            <el-option
              v-for="(item, index) in personList"
              :key="index"
              :label="item.name+'('+item.workcode+')'"
              :value="item.name+'/'+item.workcode"/>
          </el-select>
        </el-form-item>
         <el-form-item label="议事规则" prop="rules" label-width="120px">
          <el-input v-model="addForm.rules" clearable />
        </el-form-item>
        <el-form-item label="是否可用" prop="is_available" label-width="120px">
          <el-switch
            v-model="addForm.is_available"
            :title="addForm.is_available=='1'?'可用':'不可用'"
            active-value="1"
            inactive-value="0"
            active-color="#13ce66"
            inactive-color="#909399"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="closeAdd()">取消</el-button>
        <el-button v-if="isAdd" type="primary" size="small" @click="addSubmit">确定</el-button>
        <el-button v-else type="primary" size="small" @click="editSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAllSecretary, setSecretary, getDetail, editSecretary } from '../../api/secretary'
import { gitusers } from '../../api/user'
export default {
  data() {
    return {
      searchForm: {
        department: null
      },
      tableData: [],
      addVisible: false,
      isloading: false,
      isAdd: true,
      addForm: {
        department: '',
        one_person: '',
        two_person: '',
        leader_person: '',
        sector_bp_person: '',
        is_available: '1',
        rules: ''
      },
      rule: {
        department: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        one_person: [{ required: true, message: '请选择第一部门秘书', trigger: 'blur' }],
        two_person: [{ required: true, message: '请选择第二部门秘书', trigger: 'blur' }],
        leader_person: [{ required: true, message: '请选择负责人', trigger: 'blur' }],
        sector_bp_person: [{ required: false, message: '请选择部门BP', trigger: 'blur' }]
      },
      personList: [],
      page: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    // 获取所有人员
    gitusers({ departmentId: 0 }).then(res => {
      console.log(res)
      if (res.code === '000000' && res.data) {
        this.personList = res.data
      }
    }).catch(err => {
      console.log(err)
    })
    this.getList()
  },
  methods: {
    add() {
      this.isAdd = true
      this.addVisible = true
    },
    editTab(id) {
      this.isAdd = false
      this.isloading = true
      getDetail(id).then(res => {
        this.isloading = false
        if (res.code === 'success') {
          this.addForm.leader_person = []
          const personName = res.data.leader.split(',')
          const personWork = res.data.leader_workcode.split(',')
          const list = []
          for (let index = 0; index < personName.length; index++) {
            list.push(personName[index] + '/' + personWork[index])
          }
          this.addForm.leader_person = list
          // 解构需要的参数
          this.addVisible = true
          this.addForm.department = res.data.department
          this.addForm.one_person = res.data.one_name
          this.addForm.two_person = res.data.two_name

          this.addForm.sector_bp_person = res.data.sector_bp + '/' + res.data.sector_bp_workcode
          this.addForm.one = res.data.one_name + '/' + res.data.one_workcode
          this.addForm.two = res.data.two_name + '/' + res.data.two_workcode
          this.addForm.leaderAll = res.data.leader + '/' + res.data.leader_workcode
          this.addForm.bp = res.data.sector_bp + '/' + res.data.sector_bp_workcode
          this.addForm.id = res.data.id
          this.addForm.rules = res.data.rules
          this.addForm.is_available = res.data.is_available === 1 ? '1' : '0'
          this.addVisible = true
        } else {
          this.$message.error('获取详情失败！')
        }
      }).catch(err => {
        this.isloading = false
      })
    },
    closeAdd() {
      // this.$refs.addForm.resetFields()
      this.addVisible = false
      this.addForm = {
        department: '',
        one_person: '',
        two_person: '',
        leader_person: '',
        sector_bp_person: '',
        is_available: '1'
      }
    },
    addSubmit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 遍历部门负责人 名字和工号 [名字，名字] [工号，工号]
          const nameArr = []
          const workcodeArr = []
          for (let index = 0; index < this.addForm.leader_person.length; index++) {
            const element = this.addForm.leader_person[index]
            nameArr.push(element.split('/')[0])
            workcodeArr.push(element.split('/')[1])
          }
          const params = {
            department: this.addForm.department,
            one_name: this.addForm.one_person.split('/')[0],
            one_workcode: this.addForm.one_person.split('/')[1],
            two_name: this.addForm.two_person.split('/')[0],
            two_workcode: this.addForm.two_person.split('/')[1],
            is_available: this.addForm.is_available === '1' ? 1 : 0,
            leader: nameArr.toString(),
            leader_workcode: workcodeArr.toString(),
            sector_bp: this.addForm.sector_bp_person ? this.addForm.sector_bp_person.split('/')[0] : '',
            sector_bp_workcode: this.addForm.sector_bp_person ? this.addForm.sector_bp_person.split('/')[1] : '',
            rules: this.addForm.rules
          }
          if (params.one_workcode === params.two_workcode) {
            this.$message.warning('第一行政秘书和第二行政秘书不可以是同一个人')
            return
          }
          setSecretary(params).then(res => {
            if (res.code === 'success') {
              this.$message.success('创建成功')
              this.closeAdd()
              this.handleCurrentChange(1)
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          return false
        }
      })
    },
    editSubmit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 遍历部门负责人 名字和工号 [名字，名字] [工号，工号]
          const nameArr = []
          const workcodeArr = []
          for (let index = 0; index < this.addForm.leader_person.length; index++) {
            const element = this.addForm.leader_person[index]
            nameArr.push(element.split('/')[0])
            workcodeArr.push(element.split('/')[1])
          }
          // 3目运算符 代替IF 判断
          const one_name = this.addForm.one_person.indexOf('/') !== -1 ? this.addForm.one_person.split('/')[0] : this.addForm.one.split('/')[0]
          const one_workcode = this.addForm.one_person.indexOf('/') !== -1 ? this.addForm.one_person.split('/')[1] : this.addForm.one.split('/')[1]
          const two_name = this.addForm.two_person.indexOf('/') !== -1 ? this.addForm.two_person.split('/')[0] : this.addForm.two.split('/')[0]
          const two_workcode = this.addForm.two_person.indexOf('/') !== -1 ? this.addForm.two_person.split('/')[1] : this.addForm.two.split('/')[1]
          if (one_workcode === two_workcode) {
            this.$message.warning('第一行政秘书和第二行政秘书不可以是同一个人')
            return
          }
          const params = {
            department: this.addForm.department,
            one_name: one_name,
            one_workcode: one_workcode,
            two_name: two_name,
            two_workcode: two_workcode,
            is_available: this.addForm.is_available === '1' ? 1 : 0,
            leader: nameArr.toString(),
            leader_workcode: workcodeArr.toString(),
            sector_bp: this.addForm.sector_bp_person ? this.addForm.sector_bp_person.split('/')[0] : '',
            sector_bp_workcode: this.addForm.sector_bp_person ? this.addForm.sector_bp_person.split('/')[1] : '',
            rules: this.addForm.rules
          }
          editSecretary(params, this.addForm.id).then(res => {
            if (res.code === 'success') {
              this.$message.success('修改成功')
              this.closeAdd()
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          return false
        }
      })
    },
    searchList() {
      this.page = 1
      this.getList()
    },
    // 查询秘书配置列表
    getList() {
      this.isloading = true
      const params = {
        department: this.searchForm.department,
        is_available: 0,
        page: this.page,
        page_size: this.pageSize
      }
      getAllSecretary(params).then(res => {
        this.isloading = false
        console.log(res)
        if (res.code === 'success') {
          this.total = res.data.pagination.total
          res.data.secretary.forEach(item => {
            item.is_available = item.is_available === 1 ? '1' : '0'
          })
          this.tableData = res.data.secretary
          console.log(this.tableData)
        } else {
          this.total = 0
          this.tableData = []
        }
      }).catch(err => {
        this.isloading = false
        console.log(err)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    }
  }
}
</script>
<style lang="sass">

</style>
